/**
 * Product Card Video Hover/Touch Effect – Inline Style Optimized
 * --------------------------------------------------------------
 * Desktop: plays video on hover, resets and shows fallback on mouse leave.
 * Mobile: plays video fully on first tap; prevents navigation until video ends.
 * Inline styles used for visibility to minimize DOM writes.
 * Preloads all videos on mobile for reliable loading.
 * On history navigation (back/forward), resets all videos, shows fallback, and re-preloads videos.
 */

document.addEventListener('DOMContentLoaded', () => {
  const isMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
  const productCards = document.querySelectorAll('.product-card');

  // Preload videos as they approach viewport (desktop only)
  const preloadObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target.querySelector('.featured-video');
        if (video) forcePreload(video);
        preloadObserver.unobserve(entry.target);
      }
    });
  }, { rootMargin: '300px' });

  productCards.forEach(card => {
    const video = card.querySelector('.featured-video');
    const fallbackImg = card.querySelector('.video-fallback');
    const gallery = card.querySelector('.card-gallery, .product-media');
    if (!video) return;

    // Helper functions to toggle video/fallback efficiently
    const showVideo = () => {
      video.style.display = 'block';
      if (fallbackImg) fallbackImg.style.display = 'none';
    };
    const showFallback = () => {
      video.style.display = 'none';
      if (fallbackImg) fallbackImg.style.display = 'block';
    };

    // Hide all other videos and show their fallback images
    function hideOtherVideos(exceptVideo) {
      document.querySelectorAll('.featured-video').forEach(v => {
        if (v !== exceptVideo) {
          v.pause();
          v.currentTime = 0;
          v.style.display = 'none';
        }
      });
      document.querySelectorAll('.video-fallback').forEach(img => img.style.display = 'block');
    }

    if (!isMobile) {
      // DESKTOP: hover interactions
      preloadObserver.observe(card);

      card.addEventListener('mouseenter', () => {
        hideOtherVideos(video);
        showVideo();
        safePlay(video, fallbackImg);
      });

      card.addEventListener('mouseleave', () => {
        video.currentTime = 0;
        video.pause();
        showFallback();
      });
    } else {
      // MOBILE: tap to play fully, prevent navigation until done
      let videoPlaying = false;
      const tapTarget = gallery || card;

      function playVideoOnce() {
        hideOtherVideos(video);
        showVideo();
        video.currentTime = 0;
        video.muted = true;
        video.playsInline = true;

        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            showFallback();
            videoPlaying = false;
          });
        }
      }

      function preventNavigation(e) {
        if (!videoPlaying) {
          e.preventDefault();
          e.stopPropagation();
          videoPlaying = true;
          playVideoOnce();
        }
      }

      tapTarget.addEventListener('touchstart', preventNavigation, { passive: false });
      tapTarget.addEventListener('click', preventNavigation, true);

      video.addEventListener('ended', () => {
        video.currentTime = 0;
        video.pause();
        showFallback();
        videoPlaying = false;
      });

      // Preload all videos on mobile for reliable touch-play
      forcePreload(video);
    }
  });

  // Mobile: preload all videos at page load for reliable touch-play
  if (isMobile) {
    document.querySelectorAll('.featured-video').forEach(forcePreload);
  }

  // On page navigation (back/forward), reset all videos, show fallback, and re-preload videos
  window.addEventListener('pageshow', function() {
    document.querySelectorAll('.featured-video').forEach(video => {
      video.pause();
      video.currentTime = 0;
      video.style.display = 'none';
      forcePreload(video); // <--- critical fix for your issue!
    });
    document.querySelectorAll('.video-fallback').forEach(fallbackImg => {
      fallbackImg.style.display = 'block';
    });
  });

  /**
   * Forces video to preload and caches first frame for smooth playback.
   */
  function forcePreload(video) {
    try {
      video.preload = 'auto';
      video.muted = true;
      video.playsInline = true;
      video.load();

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.then(() => {
          video.pause();
          video.currentTime = 0;
        }).catch(() => { /* autoplay blocked, ignore */ });
      }
    } catch (err) {
      console.warn('Video preload error:', err);
    }
  }

  /**
   * Attempts to play video; shows fallback image if playback fails.
   */
  function safePlay(video, fallbackImg) {
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {
        if (fallbackImg) {
          video.style.display = 'none';
          fallbackImg.style.display = 'block';
        }
      });
    }
  }
});

document.addEventListener('DOMContentLoaded', function() {
    var SwiperTop = new Swiper('.marquee--text', {
        spaceBetween: 36,
        centeredSlides: true,
        speed: 10000,
        autoplay: {
            delay: 0,
        },
        loop: true,
        slidesPerView:'auto',
        allowTouchMove: false,
        disableOnInteraction: true
    });
});



//MENU DRAWER MOBILE CLICK JS START


document.querySelectorAll(".custom-menu-drawer .custom-menu-menu-item").forEach(function(el){
  el.addEventListener("click", function(){
    const drawer = document.querySelector(".header__columns .menu-drawer-container");
    
    if (drawer) {
      drawer.classList.remove("menu-open");
      drawer.removeAttribute("open");
    }
  });
});

//MENU DRAWER MOBILE CLICK JS END